var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#272DBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6666 22.6667L27.4999 12.8333C27.8055 12.5278 28.1944 12.375 28.6666 12.375C29.1388 12.375 29.5277 12.5278 29.8333 12.8333C30.1388 13.1389 30.2916 13.5278 30.2916 14C30.2916 14.4722 30.1388 14.8611 29.8333 15.1667L18.8333 26.1667C18.4999 26.5 18.111 26.6667 17.6666 26.6667C17.2221 26.6667 16.8333 26.5 16.4999 26.1667L12.1666 21.8333C11.861 21.5278 11.7083 21.1389 11.7083 20.6667C11.7083 20.1944 11.861 19.8056 12.1666 19.5C12.4721 19.1944 12.861 19.0417 13.3333 19.0417C13.8055 19.0417 14.1944 19.1944 14.4999 19.5L17.6666 22.6667Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.e08724ab814ea753645ebc118e370734.svg";
export { ForwardRef as ReactComponent };